var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesTextGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.52 59.5498L129.12 132.55C129.069 133.153 128.898 133.739 128.618 134.276C128.338 134.812 127.955 135.288 127.489 135.675C127.024 136.062 126.487 136.353 125.909 136.53C125.33 136.708 124.722 136.769 124.12 136.71L59.1201 131.02C58.5168 130.968 57.9297 130.798 57.3928 130.518C56.8558 130.238 56.3797 129.855 55.9919 129.39C55.6041 128.925 55.3124 128.388 55.1335 127.809C54.9547 127.231 54.8923 126.623 54.9501 126.02L62.3501 41.4498C62.404 40.8479 62.5763 40.2626 62.8571 39.7274C63.1378 39.1923 63.5215 38.7178 63.986 38.3313C64.4506 37.9448 64.9869 37.6538 65.5642 37.4751C66.1415 37.2964 66.7484 37.2334 67.3501 37.2898L121.59 42.0298L135.52 59.5498Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0102 29.1899L71.4402 30.7299L69.9102 13.1599L89.0102 29.1899Z",
    fill: "#B4C5D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0102 29.1899L71.4402 30.7299L69.9102 13.1599L89.0102 29.1899Z",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5701 29.3899L87.0201 34.6099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.95 59.7699L120.39 58.2299L121.92 40.6699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1301 68.03L120.33 72.07",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.29 77.5598L119.5 81.5998",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.47 87L98.6 89.29",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8701 105.21L117.08 109.25",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.04 114.74L115.89 118.75",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 110.83L23.7901 113.08C23.1882 113.138 22.5807 113.076 22.0029 112.897C21.4251 112.719 20.8882 112.428 20.4234 112.042C19.9585 111.655 19.5749 111.18 19.2946 110.644C19.0142 110.108 18.8428 109.522 18.7901 108.92L11.4001 24.3499C11.3423 23.7479 11.4044 23.1405 11.5826 22.5627C11.7608 21.9848 12.0516 21.448 12.4384 20.9832C12.8251 20.5183 13.3001 20.1347 13.8359 19.8543C14.3717 19.574 14.9577 19.4026 15.5601 19.3499L69.7901 14.6099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.27 48.3098L55.7 45.8198",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1001 57.84L55.1401 55.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9302 67.2798L54.3002 65.0598",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.52 85.4998L52.25 83.5898",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3601 95.02L51.8401 93.23",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesTextGrey);
export default __webpack_public_path__ + "static/media/pages_text_grey.44022a9900465cca92aa14c125f0994b.svg";
export { ForwardRef as ReactComponent };